module.exports = __webpack_public_path__ + "sj.svg?fb2733602a581b6b579249658ce48914";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/sj.svg
// module id = 934
// module chunks = 27